import { cyan } from '@bloomfieldrobotics/canopy';
import { PointColorConfiguration } from '../../../../../commonUI/maps/types';
import { CollectionPoint } from '../../../../types';

export type ColorablePointPropertyPath = keyof Pick<
  CollectionPoint,
  'exposure'
>;

export const EXPOSURE_COLOR_CONFIG: PointColorConfiguration<CollectionPoint> = {
  color: cyan[400],
  property: 'exposure',
  min: 100,
  max: 1000,
} as const;

export const COLOR_CONFIG_MAP: Record<
  ColorablePointPropertyPath,
  PointColorConfiguration<CollectionPoint>
> = {
  exposure: EXPOSURE_COLOR_CONFIG,
} as const;
